export default "__VITE_ASSET__BqQ7wLtu__"